export default "__VITE_ASSET__Bv5pzAjg__"